var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1868,
    height: 1868,
    viewBox: "0 0 1868 1868",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2294_4)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 934,
    cy: 934,
    r: 839,
    fill: "#052409",
    stroke: "#5D8D33",
    strokeWidth: 64
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2294_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 127,
    width: 1619,
    height: 1619
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 809.419,
    cy: 809.419,
    r: 809.419,
    transform: "matrix(-1 0 0 1 1745.84 127)",
    fill: "url(#paint0_linear_2294_4)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2294_4)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.37752,
    cy: 2.37752,
    r: 2.37752,
    transform: "matrix(-1 0 0 1 251.193 938.844)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.35917,
    cy: 1.35917,
    r: 1.35917,
    transform: "matrix(-1 0 0 1 1007.97 914.41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47682,
    cy: 1.47682,
    r: 1.47682,
    transform: "matrix(-1 0 0 1 700.469 1068.92)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.50483,
    cy: 1.50483,
    r: 1.50483,
    transform: "matrix(-1 0 0 1 1056.74 686.67)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.48975,
    cy: 1.48975,
    r: 1.48975,
    transform: "matrix(-1 0 0 1 803.479 1437.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.335,
    cy: 1.335,
    r: 1.335,
    transform: "matrix(-1 0 0 1 224.079 1224.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.63464,
    cy: 1.63464,
    r: 1.63464,
    transform: "matrix(-1 0 0 1 1025.1 1545.99)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.6863,
    cy: 1.6863,
    r: 1.6863,
    transform: "matrix(-1 0 0 1 416.777 644.477)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36862,
    cy: 2.36862,
    r: 2.36862,
    transform: "matrix(-1 0 0 1 1076.4 366.489)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37614,
    cy: 1.37614,
    r: 1.37614,
    transform: "matrix(-1 0 0 1 1344.53 1680.22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.44838,
    cy: 2.44838,
    r: 2.44838,
    transform: "matrix(-1 0 0 1 1028.3 1205.32)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.28016,
    cy: 1.28016,
    r: 1.28016,
    transform: "matrix(-1 0 0 1 1062.43 703.675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.32249,
    cy: 1.32249,
    r: 1.32249,
    transform: "matrix(-1 0 0 1 670.846 1530.21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.43344,
    cy: 1.43344,
    r: 1.43344,
    transform: "matrix(-1 0 0 1 279.329 1377.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.74224,
    cy: 1.74224,
    r: 1.74224,
    transform: "matrix(-1 0 0 1 1084.39 728.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.984,
    cy: 1.984,
    r: 1.984,
    transform: "matrix(-1 0 0 1 764.395 1467.92)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.48457,
    cy: 1.48457,
    r: 1.48457,
    transform: "matrix(-1 0 0 1 683.417 1391.54)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.55597,
    cy: 1.55597,
    r: 1.55597,
    transform: "matrix(-1 0 0 1 1066.85 1050.58)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.24563,
    cy: 2.24563,
    r: 2.24563,
    transform: "matrix(-1 0 0 1 1048.48 353.306)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.42763,
    cy: 1.42763,
    r: 1.42763,
    transform: "matrix(-1 0 0 1 825.978 405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60579,
    cy: 1.60579,
    r: 1.60579,
    transform: "matrix(-1 0 0 1 1115.73 700.721)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.7545,
    cy: 1.7545,
    r: 1.7545,
    transform: "matrix(-1 0 0 1 599.721 1694.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.08452,
    cy: 2.08452,
    r: 2.08452,
    transform: "matrix(-1 0 0 1 297.074 1122.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.80048,
    cy: 1.80048,
    r: 1.80048,
    transform: "matrix(-1 0 0 1 983.108 1701.19)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.83998,
    cy: 1.83998,
    r: 1.83998,
    transform: "matrix(-1 0 0 1 1208.39 602.128)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.43013,
    cy: 1.43013,
    r: 1.43013,
    transform: "matrix(-1 0 0 1 689.193 1082.35)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2146,
    cy: 2.2146,
    r: 2.2146,
    transform: "matrix(-1 0 0 1 1391.98 1229.91)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.42828,
    cy: 1.42828,
    r: 1.42828,
    transform: "matrix(-1 0 0 1 1372.34 1364.52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.90884,
    cy: 1.90884,
    r: 1.90884,
    transform: "matrix(-1 0 0 1 873.446 423.342)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.81994,
    cy: 1.81994,
    r: 1.81994,
    transform: "matrix(-1 0 0 1 350.54 820.688)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.47911,
    cy: 2.47911,
    r: 2.47911,
    transform: "matrix(-1 0 0 1 1682.25 250.633)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.80767,
    cy: 1.80767,
    r: 1.80767,
    transform: "matrix(-1 0 0 1 1514.53 1107.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.99473,
    cy: 1.99473,
    r: 1.99473,
    transform: "matrix(-1 0 0 1 1285.78 653.657)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66013,
    cy: 1.66013,
    r: 1.66013,
    transform: "matrix(-1 0 0 1 1215.43 987.208)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.83915,
    cy: 1.83915,
    r: 1.83915,
    transform: "matrix(-1 0 0 1 1518.68 916.521)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36828,
    cy: 2.36828,
    r: 2.36828,
    transform: "matrix(-1 0 0 1 228.059 952.399)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05385,
    cy: 2.05385,
    r: 2.05385,
    transform: "matrix(-1 0 0 1 1097.25 1724.65)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.46012,
    cy: 1.46012,
    r: 1.46012,
    transform: "matrix(-1 0 0 1 1112.11 414.349)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.77669,
    cy: 1.77669,
    r: 1.77669,
    transform: "matrix(-1 0 0 1 229.346 301.609)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.89938,
    cy: 1.89938,
    r: 1.89938,
    transform: "matrix(-1 0 0 1 424.72 1667.44)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.04614,
    cy: 2.04614,
    r: 2.04614,
    transform: "matrix(-1 0 0 1 1410.54 534.836)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.9871,
    cy: 1.9871,
    r: 1.9871,
    transform: "matrix(-1 0 0 1 1164.96 1493.04)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.26982,
    cy: 1.26982,
    r: 1.26982,
    transform: "matrix(-1 0 0 1 299.098 668.532)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25717,
    cy: 2.25717,
    r: 2.25717,
    transform: "matrix(-1 0 0 1 1284 198.672)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36036,
    cy: 2.36036,
    r: 2.36036,
    transform: "matrix(-1 0 0 1 1227.78 296.533)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.51395,
    cy: 2.51395,
    r: 2.51395,
    transform: "matrix(-1 0 0 1 673.401 690.584)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.14253,
    cy: 2.14253,
    r: 2.14253,
    transform: "matrix(-1 0 0 1 234.118 1136.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.59446,
    cy: 1.59446,
    r: 1.59446,
    transform: "matrix(-1 0 0 1 353.771 1283.76)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.76541,
    cy: 1.76541,
    r: 1.76541,
    transform: "matrix(-1 0 0 1 302.513 976.185)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.68773,
    cy: 1.68773,
    r: 1.68773,
    transform: "matrix(-1 0 0 1 1244.25 863.069)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.29359,
    cy: 2.29359,
    r: 2.29359,
    transform: "matrix(-1 0 0 1 785.951 431.928)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4393,
    cy: 2.4393,
    r: 2.4393,
    transform: "matrix(-1 0 0 1 1248.54 480.658)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.77045,
    cy: 1.77045,
    r: 1.77045,
    transform: "matrix(-1 0 0 1 164.986 777.602)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.00419,
    cy: 2.00419,
    r: 2.00419,
    transform: "matrix(-1 0 0 1 416.62 512.721)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.84793,
    cy: 1.84793,
    r: 1.84793,
    transform: "matrix(-1 0 0 1 484.395 1370.52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.46792,
    cy: 1.46792,
    r: 1.46792,
    transform: "matrix(-1 0 0 1 1164.08 991.313)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.79546,
    cy: 1.79546,
    r: 1.79546,
    transform: "matrix(-1 0 0 1 290.531 1291.84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.81707,
    cy: 1.81707,
    r: 1.81707,
    transform: "matrix(-1 0 0 1 1380.05 1515.44)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25809,
    cy: 2.25809,
    r: 2.25809,
    transform: "matrix(-1 0 0 1 700.733 785.002)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.58989,
    cy: 1.58989,
    r: 1.58989,
    transform: "matrix(-1 0 0 1 1655.27 920.594)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.61954,
    cy: 1.61954,
    r: 1.61954,
    transform: "matrix(-1 0 0 1 1064.35 731.707)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.46245,
    cy: 1.46245,
    r: 1.46245,
    transform: "matrix(-1 0 0 1 1105.1 330.281)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.79743,
    cy: 1.79743,
    r: 1.79743,
    transform: "matrix(-1 0 0 1 285.89 1170.11)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.64074,
    cy: 1.64074,
    r: 1.64074,
    transform: "matrix(-1 0 0 1 499.585 1082.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1884,
    cy: 2.1884,
    r: 2.1884,
    transform: "matrix(-1 0 0 1 216.836 777.738)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.45924,
    cy: 2.45924,
    r: 2.45924,
    transform: "matrix(-1 0 0 1 666.823 1126.77)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29744,
    cy: 1.29744,
    r: 1.29744,
    transform: "matrix(-1 0 0 1 596.533 1256.08)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.31766,
    cy: 1.31766,
    r: 1.31766,
    transform: "matrix(-1 0 0 1 253.228 279.101)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.20911,
    cy: 2.20911,
    r: 2.20911,
    transform: "matrix(-1 0 0 1 1506.33 271.448)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.71244,
    cy: 1.71244,
    r: 1.71244,
    transform: "matrix(-1 0 0 1 788.371 891.7)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.22855,
    cy: 2.22855,
    r: 2.22855,
    transform: "matrix(-1 0 0 1 612.224 1065.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.56478,
    cy: 1.56478,
    r: 1.56478,
    transform: "matrix(-1 0 0 1 1213.73 1619.09)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.50261,
    cy: 1.50261,
    r: 1.50261,
    transform: "matrix(-1 0 0 1 1398.05 703.729)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.58633,
    cy: 1.58633,
    r: 1.58633,
    transform: "matrix(-1 0 0 1 622.273 1381.26)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.13826,
    cy: 2.13826,
    r: 2.13826,
    transform: "matrix(-1 0 0 1 1213.1 1509.14)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29829,
    cy: 1.29829,
    r: 1.29829,
    transform: "matrix(-1 0 0 1 656.634 424.112)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.46329,
    cy: 2.46329,
    r: 2.46329,
    transform: "matrix(-1 0 0 1 534.667 1243.12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.13025,
    cy: 2.13025,
    r: 2.13025,
    transform: "matrix(-1 0 0 1 1158.55 649.591)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.02212,
    cy: 2.02212,
    r: 2.02212,
    transform: "matrix(-1 0 0 1 1155.06 425.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.93431,
    cy: 1.93431,
    r: 1.93431,
    transform: "matrix(-1 0 0 1 1513.35 1702.86)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5654,
    cy: 1.5654,
    r: 1.5654,
    transform: "matrix(-1 0 0 1 1200.45 930.504)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.82106,
    cy: 1.82106,
    r: 1.82106,
    transform: "matrix(-1 0 0 1 1031.13 1287.74)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30223,
    cy: 2.30223,
    r: 2.30223,
    transform: "matrix(-1 0 0 1 1431.4 515.488)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.70898,
    cy: 1.70898,
    r: 1.70898,
    transform: "matrix(-1 0 0 1 902.676 650.208)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.47483,
    cy: 2.47483,
    r: 2.47483,
    transform: "matrix(-1 0 0 1 1368.48 485.411)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.28783,
    cy: 2.28783,
    r: 2.28783,
    transform: "matrix(-1 0 0 1 252.993 1129.43)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.79182,
    cy: 1.79182,
    r: 1.79182,
    transform: "matrix(-1 0 0 1 1391.39 310.392)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.02044,
    cy: 2.02044,
    r: 2.02044,
    transform: "matrix(-1 0 0 1 1070.54 451.08)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85546,
    cy: 1.85546,
    r: 1.85546,
    transform: "matrix(-1 0 0 1 1271.16 1498.96)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.96262,
    cy: 1.96262,
    r: 1.96262,
    transform: "matrix(-1 0 0 1 1033.88 796.347)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25007,
    cy: 2.25007,
    r: 2.25007,
    transform: "matrix(-1 0 0 1 611.128 999.735)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.56668,
    cy: 1.56668,
    r: 1.56668,
    transform: "matrix(-1 0 0 1 931.571 489.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.18313,
    cy: 2.18313,
    r: 2.18313,
    transform: "matrix(-1 0 0 1 357.968 589.503)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.12455,
    cy: 2.12455,
    r: 2.12455,
    transform: "matrix(-1 0 0 1 1136.16 460.458)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.71349,
    cy: 1.71349,
    r: 1.71349,
    transform: "matrix(-1 0 0 1 1708.76 643.818)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.26548,
    cy: 2.26548,
    r: 2.26548,
    transform: "matrix(-1 0 0 1 676.801 1556.52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1143,
    cy: 2.1143,
    r: 2.1143,
    transform: "matrix(-1 0 0 1 207.578 1237.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.70661,
    cy: 1.70661,
    r: 1.70661,
    transform: "matrix(-1 0 0 1 563.707 379.969)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39916,
    cy: 2.39916,
    r: 2.39916,
    transform: "matrix(-1 0 0 1 716.315 1698.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.09449,
    cy: 2.09449,
    r: 2.09449,
    transform: "matrix(-1 0 0 1 1205.67 1713.65)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.62641,
    cy: 1.62641,
    r: 1.62641,
    transform: "matrix(-1 0 0 1 999.762 1423.15)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.48224,
    cy: 2.48224,
    r: 2.48224,
    transform: "matrix(-1 0 0 1 660.203 1393.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.40394,
    cy: 2.40394,
    r: 2.40394,
    transform: "matrix(-1 0 0 1 447.827 1143.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.15229,
    cy: 2.15229,
    r: 2.15229,
    transform: "matrix(-1 0 0 1 1677.26 659.367)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2343,
    cy: 2.2343,
    r: 2.2343,
    transform: "matrix(-1 0 0 1 1214.68 416.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75017,
    cy: 1.75017,
    r: 1.75017,
    transform: "matrix(-1 0 0 1 980.163 615.742)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.49275,
    cy: 2.49275,
    r: 2.49275,
    transform: "matrix(-1 0 0 1 1223.65 450.067)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.97408,
    cy: 1.97408,
    r: 1.97408,
    transform: "matrix(-1 0 0 1 498.168 710.567)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.79261,
    cy: 1.79261,
    r: 1.79261,
    transform: "matrix(-1 0 0 1 902.228 453.018)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.20719,
    cy: 2.20719,
    r: 2.20719,
    transform: "matrix(-1 0 0 1 1145.08 1190.91)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.32912,
    cy: 2.32912,
    r: 2.32912,
    transform: "matrix(-1 0 0 1 1237.34 559.691)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.306,
    cy: 2.306,
    r: 2.306,
    transform: "matrix(-1 0 0 1 428.459 937.609)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.14331,
    cy: 2.14331,
    r: 2.14331,
    transform: "matrix(-1 0 0 1 1451.72 617.015)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30303,
    cy: 2.30303,
    r: 2.30303,
    transform: "matrix(-1 0 0 1 798.761 849.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.7698,
    cy: 1.7698,
    r: 1.7698,
    transform: "matrix(-1 0 0 1 731.111 1137.21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.14341,
    cy: 2.14341,
    r: 2.14341,
    transform: "matrix(-1 0 0 1 768.771 1172.63)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47408,
    cy: 1.47408,
    r: 1.47408,
    transform: "matrix(-1 0 0 1 185.353 1671.9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5748,
    cy: 1.5748,
    r: 1.5748,
    transform: "matrix(-1 0 0 1 1666.36 509.732)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.43772,
    cy: 2.43772,
    r: 2.43772,
    transform: "matrix(-1 0 0 1 1182.89 1691.07)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4975,
    cy: 1.4975,
    r: 1.4975,
    transform: "matrix(-1 0 0 1 1285.99 423.635)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30324,
    cy: 2.30324,
    r: 2.30324,
    transform: "matrix(-1 0 0 1 1686.17 1666.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.27985,
    cy: 2.27985,
    r: 2.27985,
    transform: "matrix(-1 0 0 1 540.481 1673.07)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.78796,
    cy: 1.78796,
    r: 1.78796,
    transform: "matrix(-1 0 0 1 351.748 1152.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.53031,
    cy: 1.53031,
    r: 1.53031,
    transform: "matrix(-1 0 0 1 1620.7 1238.44)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.78159,
    cy: 1.78159,
    r: 1.78159,
    transform: "matrix(-1 0 0 1 283.623 182.105)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39594,
    cy: 2.39594,
    r: 2.39594,
    transform: "matrix(-1 0 0 1 882.729 299.581)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85223,
    cy: 1.85223,
    r: 1.85223,
    transform: "matrix(-1 0 0 1 1150.95 1527.97)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.50521,
    cy: 2.50521,
    r: 2.50521,
    transform: "matrix(-1 0 0 1 895.813 1710.36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.27935,
    cy: 1.27935,
    r: 1.27935,
    transform: "matrix(-1 0 0 1 634.128 897.102)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.71564,
    cy: 1.71564,
    r: 1.71564,
    transform: "matrix(-1 0 0 1 639.99 673.864)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.53088,
    cy: 1.53088,
    r: 1.53088,
    transform: "matrix(-1 0 0 1 1208.41 1378.31)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.31568,
    cy: 2.31568,
    r: 2.31568,
    transform: "matrix(-1 0 0 1 157.465 1328.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.51355,
    cy: 1.51355,
    r: 1.51355,
    transform: "matrix(-1 0 0 1 1091.11 620.975)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30862,
    cy: 2.30862,
    r: 2.30862,
    transform: "matrix(-1 0 0 1 303.389 739.672)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60923,
    cy: 1.60923,
    r: 1.60923,
    transform: "matrix(-1 0 0 1 1548.73 1544.12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.52412,
    cy: 1.52412,
    r: 1.52412,
    transform: "matrix(-1 0 0 1 599.037 199.74)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33606,
    cy: 2.33606,
    r: 2.33606,
    transform: "matrix(-1 0 0 1 271.598 197.824)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.88263,
    cy: 1.88263,
    r: 1.88263,
    transform: "matrix(-1 0 0 1 1250.54 623.129)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.17955,
    cy: 2.17955,
    r: 2.17955,
    transform: "matrix(-1 0 0 1 1043.8 1038.22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.95185,
    cy: 1.95185,
    r: 1.95185,
    transform: "matrix(-1 0 0 1 1377.57 1392.73)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.84434,
    cy: 1.84434,
    r: 1.84434,
    transform: "matrix(-1 0 0 1 1068.7 985.166)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.00834,
    cy: 2.00834,
    r: 2.00834,
    transform: "matrix(-1 0 0 1 607.15 711.259)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.96667,
    cy: 1.96667,
    r: 1.96667,
    transform: "matrix(-1 0 0 1 652.777 1390.07)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.68965,
    cy: 1.68965,
    r: 1.68965,
    transform: "matrix(-1 0 0 1 1027.82 488.631)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.47823,
    cy: 2.47823,
    r: 2.47823,
    transform: "matrix(-1 0 0 1 1585.83 1164.27)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.2938,
    cy: 1.2938,
    r: 1.2938,
    transform: "matrix(-1 0 0 1 285.089 1354.22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30559,
    cy: 2.30559,
    r: 2.30559,
    transform: "matrix(-1 0 0 1 1660.78 572.079)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.39223,
    cy: 1.39223,
    r: 1.39223,
    transform: "matrix(-1 0 0 1 1198.47 1563.47)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.50718,
    cy: 1.50718,
    r: 1.50718,
    transform: "matrix(-1 0 0 1 1280.47 576.269)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.92205,
    cy: 1.92205,
    r: 1.92205,
    transform: "matrix(-1 0 0 1 619.089 1433.93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.95176,
    cy: 1.95176,
    r: 1.95176,
    transform: "matrix(-1 0 0 1 227.518 460.407)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.86861,
    cy: 1.86861,
    r: 1.86861,
    transform: "matrix(-1 0 0 1 1515.09 1472.35)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.74072,
    cy: 1.74072,
    r: 1.74072,
    transform: "matrix(-1 0 0 1 519.838 1377.37)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.03227,
    cy: 2.03227,
    r: 2.03227,
    transform: "matrix(-1 0 0 1 1426.74 1211.63)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.10611,
    cy: 2.10611,
    r: 2.10611,
    transform: "matrix(-1 0 0 1 1512.01 1538.61)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.40511,
    cy: 1.40511,
    r: 1.40511,
    transform: "matrix(-1 0 0 1 1192.47 647.482)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.87072,
    cy: 1.87072,
    r: 1.87072,
    transform: "matrix(-1 0 0 1 202.468 266.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47201,
    cy: 1.47201,
    r: 1.47201,
    transform: "matrix(-1 0 0 1 461.54 508.029)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.38278,
    cy: 2.38278,
    r: 2.38278,
    transform: "matrix(-1 0 0 1 1494.31 1059.17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.80773,
    cy: 1.80773,
    r: 1.80773,
    transform: "matrix(-1 0 0 1 1087.66 285.388)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.80552,
    cy: 1.80552,
    r: 1.80552,
    transform: "matrix(-1 0 0 1 1537.66 514.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.22811,
    cy: 2.22811,
    r: 2.22811,
    transform: "matrix(-1 0 0 1 1103.24 905.037)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.04281,
    cy: 2.04281,
    r: 2.04281,
    transform: "matrix(-1 0 0 1 424.164 478.469)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.32859,
    cy: 2.32859,
    r: 2.32859,
    transform: "matrix(-1 0 0 1 1056.62 731.165)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.64392,
    cy: 1.64392,
    r: 1.64392,
    transform: "matrix(-1 0 0 1 1538.65 740.806)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.40875,
    cy: 2.40875,
    r: 2.40875,
    transform: "matrix(-1 0 0 1 933.903 1295.73)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.2747,
    cy: 1.2747,
    r: 1.2747,
    transform: "matrix(-1 0 0 1 1553.93 1003.81)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.19886,
    cy: 2.19886,
    r: 2.19886,
    transform: "matrix(-1 0 0 1 1295.88 1489.81)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36222,
    cy: 2.36222,
    r: 2.36222,
    transform: "matrix(-1 0 0 1 1349.06 841.748)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.02017,
    cy: 2.02017,
    r: 2.02017,
    transform: "matrix(-1 0 0 1 277.9 1229.8)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.34702,
    cy: 2.34702,
    r: 2.34702,
    transform: "matrix(-1 0 0 1 1259.4 1369.7)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.07511,
    cy: 2.07511,
    r: 2.07511,
    transform: "matrix(-1 0 0 1 156.429 309.463)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.32655,
    cy: 1.32655,
    r: 1.32655,
    transform: "matrix(-1 0 0 1 129.101 744.88)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.8232,
    cy: 1.8232,
    r: 1.8232,
    transform: "matrix(-1 0 0 1 1343.69 1640.8)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.41666,
    cy: 1.41666,
    r: 1.41666,
    transform: "matrix(-1 0 0 1 234.45 445.062)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.3929,
    cy: 2.3929,
    r: 2.3929,
    transform: "matrix(-1 0 0 1 902.091 1057.08)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.34029,
    cy: 1.34029,
    r: 1.34029,
    transform: "matrix(-1 0 0 1 532.008 1035.7)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.96122,
    cy: 1.96122,
    r: 1.96122,
    transform: "matrix(-1 0 0 1 1039.81 437.023)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.0778,
    cy: 2.0778,
    r: 2.0778,
    transform: "matrix(-1 0 0 1 759.785 749.231)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.90701,
    cy: 1.90701,
    r: 1.90701,
    transform: "matrix(-1 0 0 1 397.08 806.571)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4607,
    cy: 2.4607,
    r: 2.4607,
    transform: "matrix(-1 0 0 1 1344.15 985.459)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.27688,
    cy: 1.27688,
    r: 1.27688,
    transform: "matrix(-1 0 0 1 131.114 1304.65)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.94903,
    cy: 1.94903,
    r: 1.94903,
    transform: "matrix(-1 0 0 1 643.847 625.755)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.91502,
    cy: 1.91502,
    r: 1.91502,
    transform: "matrix(-1 0 0 1 1591.08 1136.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.81998,
    cy: 1.81998,
    r: 1.81998,
    transform: "matrix(-1 0 0 1 336.522 654.279)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85869,
    cy: 1.85869,
    r: 1.85869,
    transform: "matrix(-1 0 0 1 865.635 235.403)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.8517,
    cy: 1.8517,
    r: 1.8517,
    transform: "matrix(-1 0 0 1 1389.41 624.953)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.21495,
    cy: 2.21495,
    r: 2.21495,
    transform: "matrix(-1 0 0 1 1611.74 1469.84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.26698,
    cy: 2.26698,
    r: 2.26698,
    transform: "matrix(-1 0 0 1 1266.53 1595.54)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2578,
    cy: 2.2578,
    r: 2.2578,
    transform: "matrix(-1 0 0 1 212.76 1044.7)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.44216,
    cy: 2.44216,
    r: 2.44216,
    transform: "matrix(-1 0 0 1 961.784 1725.36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5125,
    cy: 2.5125,
    r: 2.5125,
    transform: "matrix(-1 0 0 1 1216.96 1573.56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29333,
    cy: 1.29333,
    r: 1.29333,
    transform: "matrix(-1 0 0 1 531.946 599.072)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.84355,
    cy: 1.84355,
    r: 1.84355,
    transform: "matrix(-1 0 0 1 630.807 1730.93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4503,
    cy: 1.4503,
    r: 1.4503,
    transform: "matrix(-1 0 0 1 1320.15 616.689)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.7911,
    cy: 1.7911,
    r: 1.7911,
    transform: "matrix(-1 0 0 1 1594.66 1325.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.7917,
    cy: 1.7917,
    r: 1.7917,
    transform: "matrix(-1 0 0 1 1474.92 1061.04)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.57849,
    cy: 1.57849,
    r: 1.57849,
    transform: "matrix(-1 0 0 1 513.887 1711.82)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.35701,
    cy: 1.35701,
    r: 1.35701,
    transform: "matrix(-1 0 0 1 1023.12 758.04)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.0616,
    cy: 2.0616,
    r: 2.0616,
    transform: "matrix(-1 0 0 1 651.472 1537.08)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.52337,
    cy: 1.52337,
    r: 1.52337,
    transform: "matrix(-1 0 0 1 153.835 450.225)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.38947,
    cy: 2.38947,
    r: 2.38947,
    transform: "matrix(-1 0 0 1 862.602 414.181)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.62158,
    cy: 1.62158,
    r: 1.62158,
    transform: "matrix(-1 0 0 1 965.22 418.001)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30919,
    cy: 2.30919,
    r: 2.30919,
    transform: "matrix(-1 0 0 1 1462.79 1199.4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.27321,
    cy: 1.27321,
    r: 1.27321,
    transform: "matrix(-1 0 0 1 381.116 211.807)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.65646,
    cy: 1.65646,
    r: 1.65646,
    transform: "matrix(-1 0 0 1 1615.43 625.871)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.32063,
    cy: 1.32063,
    r: 1.32063,
    transform: "matrix(-1 0 0 1 1492.19 720.244)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66727,
    cy: 1.66727,
    r: 1.66727,
    transform: "matrix(-1 0 0 1 508.798 431.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.18708,
    cy: 2.18708,
    r: 2.18708,
    transform: "matrix(-1 0 0 1 1162.82 806.451)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.97601,
    cy: 1.97601,
    r: 1.97601,
    transform: "matrix(-1 0 0 1 1092.54 1648.42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.79448,
    cy: 1.79448,
    r: 1.79448,
    transform: "matrix(-1 0 0 1 1726.37 902.23)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.65498,
    cy: 1.65498,
    r: 1.65498,
    transform: "matrix(-1 0 0 1 1007.98 794.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.76889,
    cy: 1.76889,
    r: 1.76889,
    transform: "matrix(-1 0 0 1 1315.44 745.877)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2017,
    cy: 2.2017,
    r: 2.2017,
    transform: "matrix(-1 0 0 1 891.073 1008.02)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47617,
    cy: 1.47617,
    r: 1.47617,
    transform: "matrix(-1 0 0 1 945.645 341.404)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.61513,
    cy: 1.61513,
    r: 1.61513,
    transform: "matrix(-1 0 0 1 1217.07 1082.94)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.31183,
    cy: 2.31183,
    r: 2.31183,
    transform: "matrix(-1 0 0 1 840.536 929.091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60476,
    cy: 1.60476,
    r: 1.60476,
    transform: "matrix(-1 0 0 1 1602.22 1558.16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.20692,
    cy: 2.20692,
    r: 2.20692,
    transform: "matrix(-1 0 0 1 400.853 748.87)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2851,
    cy: 2.2851,
    r: 2.2851,
    transform: "matrix(-1 0 0 1 799.454 1483.84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.53627,
    cy: 1.53627,
    r: 1.53627,
    transform: "matrix(-1 0 0 1 1221.87 1448.68)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.44932,
    cy: 1.44932,
    r: 1.44932,
    transform: "matrix(-1 0 0 1 335.209 570.738)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.34118,
    cy: 2.34118,
    r: 2.34118,
    transform: "matrix(-1 0 0 1 1116.64 233.284)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.53228,
    cy: 1.53228,
    r: 1.53228,
    transform: "matrix(-1 0 0 1 1214.22 483.333)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.68289,
    cy: 1.68289,
    r: 1.68289,
    transform: "matrix(-1 0 0 1 1111.51 1207.02)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33821,
    cy: 2.33821,
    r: 2.33821,
    transform: "matrix(-1 0 0 1 705.863 675.162)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.06604,
    cy: 2.06604,
    r: 2.06604,
    transform: "matrix(-1 0 0 1 1232.08 917.549)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.95255,
    cy: 1.95255,
    r: 1.95255,
    transform: "matrix(-1 0 0 1 1287.88 792.088)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.39223,
    cy: 1.39223,
    r: 1.39223,
    transform: "matrix(-1 0 0 1 514.389 585.78)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33026,
    cy: 2.33026,
    r: 2.33026,
    transform: "matrix(-1 0 0 1 900.605 548.294)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33309,
    cy: 2.33309,
    r: 2.33309,
    transform: "matrix(-1 0 0 1 498.247 342.653)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.40898,
    cy: 2.40898,
    r: 2.40898,
    transform: "matrix(-1 0 0 1 480.462 413.517)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.8035,
    cy: 1.8035,
    r: 1.8035,
    transform: "matrix(-1 0 0 1 1606.8 1571.93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33966,
    cy: 2.33966,
    r: 2.33966,
    transform: "matrix(-1 0 0 1 997.417 1360.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.99801,
    cy: 1.99801,
    r: 1.99801,
    transform: "matrix(-1 0 0 1 1072.54 603.638)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66411,
    cy: 1.66411,
    r: 1.66411,
    transform: "matrix(-1 0 0 1 504.088 1361.9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.07384,
    cy: 2.07384,
    r: 2.07384,
    transform: "matrix(-1 0 0 1 645.929 892.622)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.11781,
    cy: 2.11781,
    r: 2.11781,
    transform: "matrix(-1 0 0 1 135.449 399.508)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.22961,
    cy: 2.22961,
    r: 2.22961,
    transform: "matrix(-1 0 0 1 1555.58 316.424)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.38158,
    cy: 1.38158,
    r: 1.38158,
    transform: "matrix(-1 0 0 1 837.414 385.941)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60661,
    cy: 1.60661,
    r: 1.60661,
    transform: "matrix(-1 0 0 1 665.982 693.428)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.9883,
    cy: 1.9883,
    r: 1.9883,
    transform: "matrix(-1 0 0 1 693.327 384.343)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4476,
    cy: 1.4476,
    r: 1.4476,
    transform: "matrix(-1 0 0 1 362.284 917.338)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.28947,
    cy: 2.28947,
    r: 2.28947,
    transform: "matrix(-1 0 0 1 493.116 1556.36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66361,
    cy: 1.66361,
    r: 1.66361,
    transform: "matrix(-1 0 0 1 1188.31 548.213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.24426,
    cy: 2.24426,
    r: 2.24426,
    transform: "matrix(-1 0 0 1 1143.73 805.523)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.59351,
    cy: 1.59351,
    r: 1.59351,
    transform: "matrix(-1 0 0 1 668.218 1070.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.28602,
    cy: 1.28602,
    r: 1.28602,
    transform: "matrix(-1 0 0 1 1656.59 921.882)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.33373,
    cy: 1.33373,
    r: 1.33373,
    transform: "matrix(-1 0 0 1 295.883 353.227)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.40479,
    cy: 1.40479,
    r: 1.40479,
    transform: "matrix(-1 0 0 1 401.982 184.482)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.59219,
    cy: 1.59219,
    r: 1.59219,
    transform: "matrix(-1 0 0 1 662.768 1446.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4476,
    cy: 2.4476,
    r: 2.4476,
    transform: "matrix(-1 0 0 1 857.89 183.29)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36126,
    cy: 2.36126,
    r: 2.36126,
    transform: "matrix(-1 0 0 1 1530.32 585.058)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.65563,
    cy: 1.65563,
    r: 1.65563,
    transform: "matrix(-1 0 0 1 1242.71 1570.6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.42242,
    cy: 2.42242,
    r: 2.42242,
    transform: "matrix(-1 0 0 1 840.704 219.868)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.42888,
    cy: 1.42888,
    r: 1.42888,
    transform: "matrix(-1 0 0 1 1273.01 1270.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.88774,
    cy: 1.88774,
    r: 1.88774,
    transform: "matrix(-1 0 0 1 1118.53 864.061)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29053,
    cy: 1.29053,
    r: 1.29053,
    transform: "matrix(-1 0 0 1 793.149 846.584)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.50123,
    cy: 2.50123,
    r: 2.50123,
    transform: "matrix(-1 0 0 1 1294.99 521.436)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4044,
    cy: 1.4044,
    r: 1.4044,
    transform: "matrix(-1 0 0 1 655.23 332.869)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.84447,
    cy: 1.84447,
    r: 1.84447,
    transform: "matrix(-1 0 0 1 1122.73 300.411)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.29518,
    cy: 2.29518,
    r: 2.29518,
    transform: "matrix(-1 0 0 1 1604.39 1274.96)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.3064,
    cy: 1.3064,
    r: 1.3064,
    transform: "matrix(-1 0 0 1 404.139 685.68)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.31195,
    cy: 2.31195,
    r: 2.31195,
    transform: "matrix(-1 0 0 1 1217.36 1104.18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.70254,
    cy: 1.70254,
    r: 1.70254,
    transform: "matrix(-1 0 0 1 1713.99 1218.73)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.73476,
    cy: 1.73476,
    r: 1.73476,
    transform: "matrix(-1 0 0 1 1179.47 1390.26)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37678,
    cy: 2.37678,
    r: 2.37678,
    transform: "matrix(-1 0 0 1 599.099 920.204)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.36252,
    cy: 2.36252,
    r: 2.36252,
    transform: "matrix(-1 0 0 1 807.909 1410.51)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.6961,
    cy: 1.6961,
    r: 1.6961,
    transform: "matrix(-1 0 0 1 1714.87 350.456)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.09699,
    cy: 2.09699,
    r: 2.09699,
    transform: "matrix(-1 0 0 1 859.753 983.99)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.50874,
    cy: 1.50874,
    r: 1.50874,
    transform: "matrix(-1 0 0 1 700.191 1303.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.77115,
    cy: 1.77115,
    r: 1.77115,
    transform: "matrix(-1 0 0 1 1435.78 863.405)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.55233,
    cy: 1.55233,
    r: 1.55233,
    transform: "matrix(-1 0 0 1 1167.96 891.982)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.78011,
    cy: 1.78011,
    r: 1.78011,
    transform: "matrix(-1 0 0 1 621.132 200.409)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.41439,
    cy: 1.41439,
    r: 1.41439,
    transform: "matrix(-1 0 0 1 342.702 1672.67)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.28451,
    cy: 2.28451,
    r: 2.28451,
    transform: "matrix(-1 0 0 1 1628.73 1040.65)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37044,
    cy: 2.37044,
    r: 2.37044,
    transform: "matrix(-1 0 0 1 1721.52 223.327)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.66966,
    cy: 1.66966,
    r: 1.66966,
    transform: "matrix(-1 0 0 1 1142.79 575.298)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.26691,
    cy: 2.26691,
    r: 2.26691,
    transform: "matrix(-1 0 0 1 898.681 1422.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.61554,
    cy: 1.61554,
    r: 1.61554,
    transform: "matrix(-1 0 0 1 737.531 475.456)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.14683,
    cy: 2.14683,
    r: 2.14683,
    transform: "matrix(-1 0 0 1 937.012 326.234)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4571,
    cy: 1.4571,
    r: 1.4571,
    transform: "matrix(-1 0 0 1 406.541 1611.06)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.64587,
    cy: 1.64587,
    r: 1.64587,
    transform: "matrix(-1 0 0 1 588.13 1666.02)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1797,
    cy: 2.1797,
    r: 2.1797,
    transform: "matrix(-1 0 0 1 1132.77 278.88)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.16229,
    cy: 2.16229,
    r: 2.16229,
    transform: "matrix(-1 0 0 1 605.21 568.831)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.84222,
    cy: 1.84222,
    r: 1.84222,
    transform: "matrix(-1 0 0 1 1667.36 574.607)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.32807,
    cy: 1.32807,
    r: 1.32807,
    transform: "matrix(-1 0 0 1 517.062 319.394)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.45459,
    cy: 1.45459,
    r: 1.45459,
    transform: "matrix(-1 0 0 1 1068.4 567.249)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.23988,
    cy: 2.23988,
    r: 2.23988,
    transform: "matrix(-1 0 0 1 1701.13 1071.53)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.20813,
    cy: 2.20813,
    r: 2.20813,
    transform: "matrix(-1 0 0 1 1592.71 1197.51)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.48268,
    cy: 1.48268,
    r: 1.48268,
    transform: "matrix(-1 0 0 1 970.632 1065.22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.53246,
    cy: 1.53246,
    r: 1.53246,
    transform: "matrix(-1 0 0 1 1235.77 1301.29)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.17895,
    cy: 2.17895,
    r: 2.17895,
    transform: "matrix(-1 0 0 1 732.644 942.562)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.10951,
    cy: 2.10951,
    r: 2.10951,
    transform: "matrix(-1 0 0 1 1611.1 1627.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5015,
    cy: 1.5015,
    r: 1.5015,
    transform: "matrix(-1 0 0 1 1485.17 332.328)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.64167,
    cy: 1.64167,
    r: 1.64167,
    transform: "matrix(-1 0 0 1 1005.48 1440.74)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.29538,
    cy: 2.29538,
    r: 2.29538,
    transform: "matrix(-1 0 0 1 532.005 388.324)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.97611,
    cy: 1.97611,
    r: 1.97611,
    transform: "matrix(-1 0 0 1 906.195 1736.71)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.01195,
    cy: 2.01195,
    r: 2.01195,
    transform: "matrix(-1 0 0 1 404.814 963.068)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.86889,
    cy: 1.86889,
    r: 1.86889,
    transform: "matrix(-1 0 0 1 1741.31 868.222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.7254,
    cy: 1.7254,
    r: 1.7254,
    transform: "matrix(-1 0 0 1 821.879 1292.08)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.83781,
    cy: 1.83781,
    r: 1.83781,
    transform: "matrix(-1 0 0 1 417.145 1195.16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.69227,
    cy: 1.69227,
    r: 1.69227,
    transform: "matrix(-1 0 0 1 318.906 415.081)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.89247,
    cy: 1.89247,
    r: 1.89247,
    transform: "matrix(-1 0 0 1 1020.32 380.36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.71088,
    cy: 1.71088,
    r: 1.71088,
    transform: "matrix(-1 0 0 1 995.801 1258.9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.4936,
    cy: 1.4936,
    r: 1.4936,
    transform: "matrix(-1 0 0 1 1059.38 946.776)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.36663,
    cy: 1.36663,
    r: 1.36663,
    transform: "matrix(-1 0 0 1 1708.32 330.486)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47814,
    cy: 1.47814,
    r: 1.47814,
    transform: "matrix(-1 0 0 1 1028.38 1544.86)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37231,
    cy: 2.37231,
    r: 2.37231,
    transform: "matrix(-1 0 0 1 373.641 1519.81)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.507,
    cy: 2.507,
    r: 2.507,
    transform: "matrix(-1 0 0 1 1133.93 859.967)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.72538,
    cy: 1.72538,
    r: 1.72538,
    transform: "matrix(-1 0 0 1 1023.35 958.654)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.93947,
    cy: 1.93947,
    r: 1.93947,
    transform: "matrix(-1 0 0 1 1281.36 791.318)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.11379,
    cy: 2.11379,
    r: 2.11379,
    transform: "matrix(-1 0 0 1 1646.87 1396.12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.52648,
    cy: 1.52648,
    r: 1.52648,
    transform: "matrix(-1 0 0 1 1517.7 486.203)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.97785,
    cy: 1.97785,
    r: 1.97785,
    transform: "matrix(-1 0 0 1 1405.16 379.931)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.10822,
    cy: 2.10822,
    r: 2.10822,
    transform: "matrix(-1 0 0 1 388.979 284.703)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.14219,
    cy: 2.14219,
    r: 2.14219,
    transform: "matrix(-1 0 0 1 970.811 1446.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54669,
    cy: 1.54669,
    r: 1.54669,
    transform: "matrix(-1 0 0 1 1266.11 1086.94)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.15754,
    cy: 2.15754,
    r: 2.15754,
    transform: "matrix(-1 0 0 1 1079.93 240.21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.31864,
    cy: 1.31864,
    r: 1.31864,
    transform: "matrix(-1 0 0 1 934.804 1308.92)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.41766,
    cy: 1.41766,
    r: 1.41766,
    transform: "matrix(-1 0 0 1 1346.98 605.798)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.03491,
    cy: 2.03491,
    r: 2.03491,
    transform: "matrix(-1 0 0 1 1177.56 1139.72)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.0853,
    cy: 2.0853,
    r: 2.0853,
    transform: "matrix(-1 0 0 1 359.084 1399.88)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.31546,
    cy: 2.31546,
    r: 2.31546,
    transform: "matrix(-1 0 0 1 1143.93 436.171)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.47755,
    cy: 1.47755,
    r: 1.47755,
    transform: "matrix(-1 0 0 1 1160.77 859.583)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29609,
    cy: 1.29609,
    r: 1.29609,
    transform: "matrix(-1 0 0 1 733.427 260.133)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2681,
    cy: 2.2681,
    r: 2.2681,
    transform: "matrix(-1 0 0 1 797.717 1142.25)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.60602,
    cy: 1.60602,
    r: 1.60602,
    transform: "matrix(-1 0 0 1 818.428 1719.57)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.68384,
    cy: 1.68384,
    r: 1.68384,
    transform: "matrix(-1 0 0 1 959.315 1096.4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.96623,
    cy: 1.96623,
    r: 1.96623,
    transform: "matrix(-1 0 0 1 323.382 726.505)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.58113,
    cy: 1.58113,
    r: 1.58113,
    transform: "matrix(-1 0 0 1 321.353 625.931)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.55656,
    cy: 1.55656,
    r: 1.55656,
    transform: "matrix(-1 0 0 1 885.744 354.737)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.42532,
    cy: 1.42532,
    r: 1.42532,
    transform: "matrix(-1 0 0 1 759.203 1583.61)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.57407,
    cy: 1.57407,
    r: 1.57407,
    transform: "matrix(-1 0 0 1 521.169 338.092)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.37042,
    cy: 1.37042,
    r: 1.37042,
    transform: "matrix(-1 0 0 1 636.286 1298.78)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.02335,
    cy: 2.02335,
    r: 2.02335,
    transform: "matrix(-1 0 0 1 186.021 892.273)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.81529,
    cy: 1.81529,
    r: 1.81529,
    transform: "matrix(-1 0 0 1 380.396 726.429)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.16734,
    cy: 2.16734,
    r: 2.16734,
    transform: "matrix(-1 0 0 1 1331.44 1502.91)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.57472,
    cy: 1.57472,
    r: 1.57472,
    transform: "matrix(-1 0 0 1 1737.04 1418.18)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.9394,
    cy: 1.9394,
    r: 1.9394,
    transform: "matrix(-1 0 0 1 1419.17 709.588)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30673,
    cy: 2.30673,
    r: 2.30673,
    transform: "matrix(-1 0 0 1 694.692 779.394)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.26407,
    cy: 2.26407,
    r: 2.26407,
    transform: "matrix(-1 0 0 1 1161.67 844.073)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39513,
    cy: 2.39513,
    r: 2.39513,
    transform: "matrix(-1 0 0 1 1294.3 547.035)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.38736,
    cy: 1.38736,
    r: 1.38736,
    transform: "matrix(-1 0 0 1 1117.51 1051.92)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.64888,
    cy: 1.64888,
    r: 1.64888,
    transform: "matrix(-1 0 0 1 180.042 1135.03)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37727,
    cy: 2.37727,
    r: 2.37727,
    transform: "matrix(-1 0 0 1 528.876 924.237)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.19336,
    cy: 2.19336,
    r: 2.19336,
    transform: "matrix(-1 0 0 1 488.841 1185.14)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37019,
    cy: 2.37019,
    r: 2.37019,
    transform: "matrix(-1 0 0 1 131.006 1334.82)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5697,
    cy: 1.5697,
    r: 1.5697,
    transform: "matrix(-1 0 0 1 1539.48 748.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.51827,
    cy: 2.51827,
    r: 2.51827,
    transform: "matrix(-1 0 0 1 1418.88 766.363)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.83545,
    cy: 1.83545,
    r: 1.83545,
    transform: "matrix(-1 0 0 1 356.024 211.934)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.46187,
    cy: 2.46187,
    r: 2.46187,
    transform: "matrix(-1 0 0 1 360.259 914.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.36205,
    cy: 1.36205,
    r: 1.36205,
    transform: "matrix(-1 0 0 1 269.399 1001.53)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.11185,
    cy: 2.11185,
    r: 2.11185,
    transform: "matrix(-1 0 0 1 1095.79 1090.9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.69324,
    cy: 1.69324,
    r: 1.69324,
    transform: "matrix(-1 0 0 1 1589.13 1150.21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.68249,
    cy: 1.68249,
    r: 1.68249,
    transform: "matrix(-1 0 0 1 162.098 665.222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.28989,
    cy: 1.28989,
    r: 1.28989,
    transform: "matrix(-1 0 0 1 1045.18 1437.55)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.56026,
    cy: 1.56026,
    r: 1.56026,
    transform: "matrix(-1 0 0 1 1467.8 1019.88)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.41642,
    cy: 1.41642,
    r: 1.41642,
    transform: "matrix(-1 0 0 1 480.553 1505.47)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.63413,
    cy: 1.63413,
    r: 1.63413,
    transform: "matrix(-1 0 0 1 750.979 243.919)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.95965,
    cy: 1.95965,
    r: 1.95965,
    transform: "matrix(-1 0 0 1 142.99 607.436)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39651,
    cy: 2.39651,
    r: 2.39651,
    transform: "matrix(-1 0 0 1 1449.61 1468.71)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37004,
    cy: 2.37004,
    r: 2.37004,
    transform: "matrix(-1 0 0 1 1392.79 735.233)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.41926,
    cy: 1.41926,
    r: 1.41926,
    transform: "matrix(-1 0 0 1 1111.05 1577.24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.88083,
    cy: 1.88083,
    r: 1.88083,
    transform: "matrix(-1 0 0 1 1222.81 1245.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.16508,
    cy: 2.16508,
    r: 2.16508,
    transform: "matrix(-1 0 0 1 1032.14 217.758)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.30567,
    cy: 1.30567,
    r: 1.30567,
    transform: "matrix(-1 0 0 1 984.187 1215.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.19972,
    cy: 2.19972,
    r: 2.19972,
    transform: "matrix(-1 0 0 1 448.879 756.767)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.98782,
    cy: 1.98782,
    r: 1.98782,
    transform: "matrix(-1 0 0 1 1696.7 688.882)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4969,
    cy: 2.4969,
    r: 2.4969,
    transform: "matrix(-1 0 0 1 956.462 1322.54)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.30244,
    cy: 2.30244,
    r: 2.30244,
    transform: "matrix(-1 0 0 1 174.095 545.453)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.81863,
    cy: 1.81863,
    r: 1.81863,
    transform: "matrix(-1 0 0 1 937.337 680.879)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.05222,
    cy: 2.05222,
    r: 2.05222,
    transform: "matrix(-1 0 0 1 223.037 1694.64)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.71508,
    cy: 1.71508,
    r: 1.71508,
    transform: "matrix(-1 0 0 1 810.769 683.409)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.27174,
    cy: 1.27174,
    r: 1.27174,
    transform: "matrix(-1 0 0 1 1235.12 726.577)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54349,
    cy: 1.54349,
    r: 1.54349,
    transform: "matrix(-1 0 0 1 321.6 659.925)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.43232,
    cy: 1.43232,
    r: 1.43232,
    transform: "matrix(-1 0 0 1 533.941 1366.1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.24069,
    cy: 2.24069,
    r: 2.24069,
    transform: "matrix(-1 0 0 1 1156.19 733.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.46456,
    cy: 1.46456,
    r: 1.46456,
    transform: "matrix(-1 0 0 1 1497.81 765.069)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.56007,
    cy: 1.56007,
    r: 1.56007,
    transform: "matrix(-1 0 0 1 967.679 786.256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.06764,
    cy: 2.06764,
    r: 2.06764,
    transform: "matrix(-1 0 0 1 1724.64 1415.96)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.31346,
    cy: 1.31346,
    r: 1.31346,
    transform: "matrix(-1 0 0 1 1479.57 1328.31)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.85751,
    cy: 1.85751,
    r: 1.85751,
    transform: "matrix(-1 0 0 1 1032.89 425.213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.7 861.396C1449.7 876.545 1454.06 891.694 1473.68 891.694C1454.06 891.694 1449.7 909.006 1449.7 921.991C1449.7 909.006 1445.34 891.694 1425.71 891.694C1445.34 891.694 1449.7 876.545 1449.7 861.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.891 1012.88C348.891 1028.03 353.252 1043.18 372.876 1043.18C353.252 1043.18 348.891 1060.5 348.891 1073.48C348.891 1060.5 344.53 1043.18 324.906 1043.18C344.53 1043.18 348.891 1028.03 348.891 1012.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.51 632.794C1572.51 647.943 1576.87 663.092 1596.49 663.092C1576.87 663.092 1572.51 680.404 1572.51 693.389C1572.51 680.404 1568.15 663.092 1548.52 663.092C1568.15 663.092 1572.51 647.943 1572.51 632.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.642 361.49C934.642 370.326 937.167 379.163 948.529 379.163C937.167 379.163 934.642 389.262 934.642 396.837C934.642 389.262 932.117 379.163 920.756 379.163C932.117 379.163 934.642 370.326 934.642 361.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.845 427.134C598.845 435.971 601.37 444.808 612.731 444.808C601.37 444.808 598.845 454.907 598.845 462.481C598.845 454.907 596.32 444.808 584.959 444.808C596.32 444.808 598.845 435.971 598.845 427.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.277 735.158C235.277 743.995 237.802 752.831 249.163 752.831C237.802 752.831 235.277 762.931 235.277 770.505C235.277 762.931 232.752 752.831 221.39 752.831C232.752 752.831 235.277 743.995 235.277 735.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 261.787 1182.04)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 491.542 1285.56)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 1501.46 947.24)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 776.842 505.403)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 1086.67 1175.16)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 980.907 811.776)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.04957,
    cy: 5.04957,
    r: 5.04957,
    transform: "matrix(-1 0 0 1 1163.14 470.056)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.615 898.555C862.615 907.391 865.14 916.228 876.501 916.228C865.14 916.228 862.615 926.327 862.615 933.902C862.615 926.327 860.09 916.228 848.729 916.228C860.09 916.228 862.615 907.391 862.615 898.555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.49,
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1509.53 879.648C1486.98 842.161 1445.24 879.648 1454.35 898.67C1419.81 886.137 1395.82 900.349 1416.93 914.337C1438.04 928.324 2071.8 962.979 2073.33 898.67C2073.72 882.556 2047.26 883.004 2033.99 885.243C2019.78 860.177 1998 864.728 1988.88 870.136C1974.3 823.586 1944.42 838.804 1931.3 852.232C1940.74 815.119 1931.3 709 1813.75 709C1695.02 709 1671.72 779.684 1686.59 834.328C1650.6 780.616 1600.22 793.858 1577.19 841.602C1529.69 830.971 1509.53 852.792 1509.53 879.648Z",
    fill: "url(#paint1_linear_2294_4)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49,
    style: {
      mixBlendMode: "screen"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.6475 887.796C-48.9532 857.526 -93.9446 887.796 -84.1188 903.156C-121.353 893.036 -147.21 904.512 -124.456 915.807C-101.702 927.101 581.342 955.084 582.994 903.156C583.407 890.145 554.896 890.506 540.588 892.314C525.281 872.073 501.802 875.748 491.977 880.115C476.256 842.526 444.055 854.815 429.92 865.658C440.09 835.689 429.92 750 303.22 750C175.26 750 150.146 807.076 166.178 851.201C127.392 807.829 73.0921 818.521 48.2693 857.074C-2.92773 848.49 -24.6475 866.11 -24.6475 887.796Z",
    fill: "url(#paint2_linear_2294_4)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M943.844 244.124C968.206 199.699 1033.11 232.181 1033.11 254.872C1043.26 249.796 1050.13 244.124 1068.94 259.947C1072.21 262.699 1068.94 270.994 1068.94 270.994C1062.84 277.223 929.233 283.076 891 270.994C891 238.451 928.319 235.764 943.844 244.124Z",
    fill: "url(#paint3_linear_2294_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.93 1300.69C1156.94 1306.47 1133.2 1364.68 1133.2 1389.46C1072.36 1363.31 1026.16 1389.46 1026.16 1447.25C1011.14 1423.58 976.316 1427.52 973.061 1447.25C916.876 1413.67 894.317 1452.99 879.544 1475.12C824.962 1466.41 725.336 1465.01 763.494 1529.14C801.651 1593.26 919.104 1561.82 973.061 1538.08C1044.87 1613.49 1191.02 1569.5 1255.11 1538.08C1313.1 1581.57 1431.76 1566.52 1483.84 1553.56C1518.39 1577.99 1624.67 1559.07 1645.71 1529.14C1662.53 1505.19 1619.67 1494.85 1596.13 1492.67C1580.81 1464.87 1552.94 1481.08 1540.92 1492.67C1530.41 1450.83 1498.48 1463.54 1483.84 1475.12C1441.17 1405.21 1397.45 1445.99 1380.93 1475.12C1379.55 1461.7 1373.79 1425.79 1361.78 1389.46C1346.75 1344.04 1287.41 1293.47 1214.93 1300.69Z",
    fill: "url(#paint4_linear_2294_4)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M566.454 1654C534.738 1640.46 475.369 1607.72 409.831 1551.9C384.723 1530.52 358.709 1505.74 332.999 1477.36C318.194 1461.02 303.49 1443.48 289.117 1424.7C273.206 1403.91 257.702 1381.61 242.915 1357.73C236.635 1347.59 230.485 1337.17 224.488 1326.46C209.816 1300.25 196.063 1272.31 183.581 1242.59C154.973 1174.46 133.037 1096.94 122 1009.26C183.698 901.121 311.391 814.5 367.893 784.545C462.311 736.945 579.118 665.711 625.719 636.045C625.882 635.676 626.047 635.303 626.216 634.926C634.827 615.675 651.18 586.371 674.453 555.101C675.309 553.951 676.174 552.799 677.048 551.645C681.292 546.04 685.755 540.382 690.434 534.717C719.458 499.572 756.748 464.148 801.191 439.417C802.633 438.615 804.082 437.824 805.538 437.045C809.425 435.706 813.811 434.265 818.631 432.756C834.065 427.925 853.946 422.398 876.117 417.325C907.634 410.113 943.78 403.816 978.366 401.731C991.004 400.969 1003.43 400.769 1015.35 401.292C1021.01 401.541 1026.56 401.953 1031.96 402.545C1031.96 402.545 1047.01 403.857 1067.14 406.029C1103.5 409.951 1156.44 416.679 1167.2 423.545C1172.6 426.991 1180.56 431.904 1189.91 437.436C1209.51 449.029 1235.23 463.338 1256.35 472.545C1259.64 475.575 1263.22 479.726 1266.43 484.771C1271.53 492.781 1275.71 503.046 1276.39 514.665C1276.54 517.247 1276.52 519.896 1276.3 522.603C1275.7 529.885 1273.64 537.579 1269.56 545.494C1266.5 551.448 1262.3 557.526 1256.72 563.647C1255.08 559.798 1250.05 555.712 1240.06 554.877C1237.42 554.574 1234.6 554.605 1231.61 554.916C1220.89 555.777 1206.28 559.638 1186.8 568.661C1183.41 569.934 1179.92 571.237 1176.32 572.545C1162.81 577.85 1141.68 585.482 1119.4 592.312C1093.88 599.402 1070.21 604.494 1054.4 607.397C1050.12 607.857 1046.16 608.087 1042.6 608.045C1043.58 608.079 1043.45 608.172 1043.31 608.266C1043.16 608.369 1043 608.474 1044.4 608.5C1043.53 608.651 1044.16 608.719 1044.76 608.782C1045.3 608.839 1045.8 608.893 1045.13 609L1065.45 608.318C1075.75 608.25 1087.49 607.936 1098.99 607.192L1119.59 606.5C1127.68 604.329 1135.71 602.824 1143.51 601.843C1152 601.01 1161.83 600.424 1171.77 600.427C1174.33 600.428 1176.89 600.468 1179.44 600.553C1193.78 601.029 1207.71 602.921 1217.55 607.265C1250.72 628.656 1216.22 648.42 1177.65 661.063C1176.6 661.407 1175.55 661.745 1174.5 662.078C1162.2 665.435 1147.42 668.633 1129.72 671.545L1128.97 671.679L1128.07 671.842L1127.25 671.991C1112.52 674.663 1093.76 678.24 1074.02 682.267C1059.96 685.134 1045.41 688.228 1031.48 691.385C1029.64 691.802 1027.8 692.221 1025.99 692.64C1013 695.634 1000.68 698.665 989.983 701.593L989.658 701.682C978.797 704.661 969.614 707.532 963.095 710.148C959.19 711.716 956.24 713.192 954.459 714.545C952.808 715.281 951.123 716.039 949.405 716.82C915.997 732.007 870.2 755.627 821.87 785.201C730.871 840.885 630.893 917.68 587.729 999.045C584.572 1004.36 581.196 1009.91 577.663 1015.71L577.662 1015.71C537.79 1081.21 477.955 1179.51 488.034 1346.89C493.111 1431.2 515.929 1533.04 567.974 1657.04L566.454 1654Z",
    fill: "#427433"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M880.5 581.5C989.5 589.5 1029.5 581.5 1146.5 520.451C1200.49 488.186 1234.44 487.345 1254.76 498.412C1265.33 504.169 1272.21 513.148 1276.3 522.603C1275.7 529.885 1273.64 537.579 1269.56 545.494C1266.5 551.448 1262.3 557.526 1256.72 563.647C1256.09 562.163 1254.95 560.643 1253.22 559.288C1250.46 557.13 1246.2 555.39 1240.06 554.877C1237.42 554.574 1234.6 554.605 1231.61 554.916C1220.89 555.777 1206.28 559.638 1186.8 568.661C1183.41 569.934 1179.92 571.237 1176.32 572.545C1162.81 577.85 1141.68 585.482 1119.4 592.312C1093.88 599.402 1070.21 604.494 1054.4 607.397C1050.12 607.857 1046.16 608.087 1042.6 608.045C1043.58 608.079 1043.45 608.172 1043.31 608.266C1043.16 608.369 1043 608.474 1044.4 608.5C1043.53 608.651 1044.16 608.719 1044.76 608.782C1045.3 608.839 1045.8 608.893 1045.13 609L1065.45 608.318C1075.75 608.25 1087.49 607.936 1098.99 607.192L1119.59 606.5C1127.68 604.329 1135.71 602.824 1143.51 601.843C1152 601.01 1161.83 600.424 1171.77 600.427C1174.33 600.428 1176.89 600.468 1179.44 600.553C1193.78 601.029 1207.71 602.921 1217.55 607.265C1222.24 610.288 1225.57 613.278 1227.74 616.221C1230.75 620.318 1231.49 624.322 1230.45 628.191C1226.93 641.206 1203.18 652.695 1177.65 661.063C1176.6 661.407 1175.55 661.745 1174.5 662.078C1162.2 665.435 1147.42 668.633 1129.72 671.545L1128.97 671.679L1128.07 671.842L1127.25 671.991C1113.65 674.458 1096.61 677.698 1078.53 681.351C1075.53 681.957 1072.38 682.304 1069.32 682.323C916.503 683.255 900.886 596.389 880.5 581.5Z",
    fill: "url(#paint5_linear_2294_4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M929.5 600.427C1017 609 1224 548.5 1231.61 505.5C1232.84 504.597 1253.54 499.279 1254.76 498.412C1265.33 504.169 1272.21 513.148 1276.3 522.603C1276.17 524.15 1275.98 525.715 1275.71 527.298C1275.62 527.827 1275.53 528.358 1275.42 528.89C1274.37 534.265 1272.48 539.823 1269.56 545.494C1266.5 551.448 1262.3 557.526 1256.72 563.647C1256.09 562.163 1254.95 560.643 1253.22 559.288C1250.46 557.13 1246.2 555.39 1240.06 554.877C1237.41 554.574 1234.6 554.605 1231.61 554.916C1230.77 554.983 1229.91 555.069 1229.02 555.174C1227.96 555.3 1226.87 555.453 1225.74 555.636C1215.73 557.255 1202.93 561.187 1186.8 568.661C1183.41 569.934 1179.92 571.237 1176.32 572.545C1170.37 574.881 1162.95 577.667 1154.6 580.638C1143.98 584.415 1131.87 588.489 1119.4 592.312C1093.88 599.402 1070.21 604.494 1054.4 607.397C1050.12 607.857 1046.16 608.087 1042.59 608.045C1043.58 608.079 1043.45 608.172 1043.31 608.266C1043.15 608.369 1043 608.474 1044.4 608.5C1043.53 608.651 1044.16 608.719 1044.76 608.782C1045.29 608.84 1045.8 608.893 1045.13 609L1065.45 608.318C1075.75 608.25 1087.49 607.936 1098.98 607.192L1119.59 606.5C1127.68 604.329 1135.71 602.824 1143.51 601.843C1152 601.01 1161.83 600.424 1171.77 600.427C1174.33 600.428 1176.89 600.468 1179.44 600.553C1193.78 601.029 1207.71 602.921 1217.55 607.265C1222.24 610.288 1225.57 613.278 1227.74 616.221C1230.75 620.318 1231.49 624.322 1230.45 628.191C1222.5 634.5 1217.51 637.092 1208.5 640.5C1051.43 676.143 952.539 607.313 929.5 600.427Z",
    fill: "#AFCB37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1624.38 1362.54L1625.39 1368.04C1624.97 1366.35 1624.56 1364.66 1624.13 1362.97C1583.01 1434.52 1532.61 1493.83 1477.68 1542.64C1290.34 1709.12 1050.34 1753.42 946.172 1744.55L946.129 1744.54C957.427 1738.3 968.287 1732.07 978.72 1725.86C1376.63 1488.97 1153.89 1278.4 951.203 1340.7C941.794 1343.6 932.429 1347.08 923.17 1351.17C915.542 1354.54 907.987 1358.33 900.541 1362.54C751.583 1473.61 621.879 1423.73 522.85 1385.65C511.762 1381.39 501.059 1377.27 490.756 1373.54C485.077 1341.43 483.185 1284.14 496.033 1216.88C506.907 1159.95 528.341 1095.88 566.978 1033.87C573.635 1023.18 580.803 1012.56 588.517 1002.04C596.259 1015.61 615.571 1033.38 648.104 1041.68C664.15 1045.77 683.411 1047.56 706.087 1045.4C725.91 1043.52 748.342 1038.62 773.515 1029.61C774.486 1029.26 775.461 1028.9 776.44 1028.54C777.735 1027.99 779.031 1027.44 780.327 1026.89C782.889 1025.81 785.452 1024.74 788.018 1023.68C806.093 1016.24 824.287 1009.43 842.556 1003.25C996.334 951.271 1155.3 944.592 1290.96 989.578C1311.01 996.223 1330.54 1004 1349.47 1012.92C1352.45 1014.32 1355.42 1015.76 1358.37 1017.22C1374.17 1025.04 1389.53 1033.69 1404.4 1043.16C1425.61 1056.67 1445.82 1071.88 1464.87 1088.8C1479.88 1102.15 1494.18 1116.56 1507.67 1132.07C1515.4 1140.95 1522.87 1150.19 1530.06 1159.79C1555.68 1193.99 1577.78 1232.77 1595.7 1276.28C1606.85 1303.34 1616.38 1332.22 1624.13 1362.97C1624.21 1362.83 1624.29 1362.69 1624.38 1362.54Z",
    fill: "#245527"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.81 1250.84C1317.84 1225.08 1280.78 1214.4 1240.61 1214.01C1190.44 1213.53 1135.44 1229.11 1083.42 1251.48C1016.02 1280.46 953.619 1320.81 913.204 1352.34C916.562 1351.92 919.884 1351.53 923.17 1351.17C1131.87 1258.91 1395.1 1477.98 978.72 1725.86C968.227 1732.34 957.371 1738.58 946.172 1744.55C1016.43 1750.53 1148.48 1732.33 1284.49 1668.76C1287.45 1667.38 1290.4 1665.98 1293.36 1664.56C1355.65 1634.56 1418.52 1594.98 1476.41 1543.77C1476.6 1543.6 1476.78 1543.44 1476.97 1543.27C1477.21 1543.06 1477.45 1542.85 1477.68 1542.64C1482.48 1530.69 1490.11 1500.87 1493.69 1485.84C1493.61 1478.17 1491.79 1466.21 1487.41 1451.07C1473.81 1404.01 1435.49 1326.19 1347.81 1250.84Z",
    fill: "#183D1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M951.203 1340.7L991.21 1301.5C797.127 1381.59 591.236 1345.41 496.033 1216.88C483.185 1284.14 485.077 1341.43 490.756 1373.54L491.248 1373.72C501.399 1377.4 511.939 1381.45 522.85 1385.65C528.843 1387.96 534.949 1390.3 541.165 1392.66C637.65 1429.18 760.598 1466.89 900.541 1362.54C907.987 1358.33 915.542 1354.54 923.17 1351.17C932.429 1347.08 941.794 1343.6 951.203 1340.7Z",
    fill: "#1D481F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.85 600C1216.62 590 1190.45 590.833 1179.64 592.5L1200.41 579C1291.58 584.5 1328.56 636 1338.69 656.5C1348.82 677 1341.73 694 1367.56 718C1388.23 737.2 1411.97 741 1421.26 740.5C1364.52 744.1 1335.82 715.333 1328.56 700.5C1328.56 724.1 1311.34 750.667 1302.73 761C1306.1 752 1310.83 724.9 1302.73 688.5C1292.6 643 1257.65 612.5 1234.85 600Z",
    fill: "url(#paint6_linear_2294_4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.4 1043.16C1425.61 1056.67 1447.29 1071.57 1466.34 1088.5L1507.67 1132.07C1515.4 1140.95 1522.87 1150.19 1530.06 1159.79C1555.68 1193.99 1577.78 1232.77 1595.7 1276.28C1364.61 911.249 948.221 1042.96 739.97 1039.5C740.941 1039.15 775.461 1028.9 776.44 1028.54C777.735 1027.99 779.031 1027.44 780.327 1026.89C782.889 1025.81 785.452 1024.74 788.018 1023.68C806.093 1016.24 824.287 1009.43 842.556 1003.25C852.431 999.913 862.328 996.762 872.239 993.799C886.787 989.45 901.365 985.507 915.949 981.975C1046.14 950.452 1176.8 951.722 1290.96 989.578C1311.01 996.223 1330.54 1004 1349.47 1012.92C1352.45 1014.32 1355.42 1015.76 1358.37 1017.22C1360.08 1018.07 1361.79 1018.92 1363.48 1019.79C1369.18 1022.69 1374.82 1025.7 1380.4 1028.82C1388.53 1033.37 1396.54 1038.15 1404.4 1043.16Z",
    fill: "#356F26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1634 1345C1633.44 1344.25 1632.61 1342.53 1631.52 1339.99C1632.35 1341.65 1633.18 1343.32 1634 1345Z",
    fill: "#356F26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M915.949 981.975C1064.92 980.862 1239.19 996.088 1380.4 1028.82C1374.82 1025.7 1369.18 1022.69 1363.48 1019.79C1361.78 1018.92 1360.08 1018.07 1358.37 1017.22C1355.42 1015.76 1352.45 1014.32 1349.47 1012.92C1348.36 1012.4 1347.26 1011.88 1346.14 1011.36C1336.93 1007.1 1327.57 1003.11 1318.08 999.385C1309.16 995.88 1300.11 992.611 1290.96 989.578C1226.32 968.141 1156.38 958.436 1084.23 959.774C1028.97 960.799 972.415 968.302 915.949 981.975Z",
    fill: "#578734"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.23 959.774C1156.38 958.436 1226.32 968.141 1290.96 989.578C1300.11 992.611 1309.16 995.88 1318.08 999.385C1243.22 982.822 1155.65 969.448 1084.23 959.774Z",
    fill: "#82AA36"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.36 1664.56C1487.58 1358.85 1240.61 1236 1083.42 1251.5C1135.38 1229.8 1190.22 1214.48 1240.61 1214.01C1280.78 1214.4 1325.95 1230.08 1355.91 1255.84C1443.6 1331.19 1473.81 1404.01 1487.41 1451.07C1491.79 1466.21 1493.61 1478.17 1493.69 1485.84C1490.11 1500.87 1482.48 1530.69 1477.68 1542.64L1476.97 1543.27L1476.41 1543.77C1418.52 1594.98 1355.65 1634.56 1293.36 1664.56Z",
    fill: "#1B451D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M991.704 443.35C965.364 446.55 945.271 458.683 938.518 464.35C953.106 456.75 969.247 455.516 975.494 455.85C968.91 459.35 966.883 470.35 966.883 474.35C966.883 477.99 964.857 492.85 981.066 500.85C997.275 508.85 1015 510.35 1023.62 507.85C1030.5 505.85 1052.15 494.35 1062.11 488.85C1070.22 490.85 1075.28 489.683 1076.8 488.85C1067.18 487.35 1062.11 484.85 1051.98 477.85C1041.85 470.85 1024.63 439.35 991.704 443.35Z",
    fill: "#104216"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M972.528 479.812C971.717 470.612 977.931 461.312 981.139 457.812C996.335 454.312 1012.51 454.041 1024.19 460.312C1035.17 468.192 1040.79 475.407 1043.33 478.665L1043.44 478.812C1047.49 484.012 1053.91 487.646 1055.6 488.312C1051.88 490.479 1043.34 495.512 1038.88 498.312C1033.31 501.812 1013.99 509 997.854 504.312C981.701 499.62 973.541 491.312 972.528 479.812Z",
    fill: "#FFF4D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.29 481.85C1037.29 495.933 1026.23 505.85 1011.96 505.85C997.698 505.85 985.625 495.933 985.625 481.85C985.625 467.766 997.191 456.35 1011.46 456.35C1016.23 456.35 1020.29 458.125 1024.12 460.35C1031.76 464.78 1037.29 472.474 1037.29 481.85Z",
    fill: "#BBD236"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.96 495.35C1003.86 491.75 1000.99 465.85 1000.82 453.35L1021.59 454.35C1024.83 471.15 1016.52 491.35 1011.96 495.35Z",
    fill: "#104216"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.11 518.761C1175.83 520.561 1168.82 522.761 1165.44 523.761C1165.44 523.761 1171.02 527.261 1177.6 528.261C1184.19 529.261 1196.85 529.361 1194.82 521.761C1192.29 512.261 1180.39 516.961 1178.11 518.761Z",
    fill: "#104216"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M566.978 1033.87C591.431 1044.07 677.16 1079 779.479 1028.5C708.058 1050 686.277 1049.5 648.104 1041.68C635.098 1039.01 622.208 1032.55 611.582 1025.06C601.64 1018.06 593.68 1010.15 589.463 1003.6C589.123 1003.07 588.807 1002.55 588.517 1002.04C580.803 1012.56 573.635 1023.18 566.978 1033.87Z",
    fill: "#397032"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M534.76 1147.73L573.373 1075.22L611.582 1025.06C601.64 1018.06 593.68 1010.15 589.463 1003.6C587.138 1007.14 584.415 1013.55 581.929 1017.25L581.908 1017.28L581.907 1017.28C539.882 1079.75 476.817 1173.51 487.44 1333.15C488.196 1346.22 489.448 1359.74 491.249 1373.72C501.399 1377.4 511.939 1381.45 522.85 1385.65C528.843 1387.96 534.949 1390.3 541.165 1392.66L542.587 1392.91L534.76 1371.45L519.628 1318.5L514.932 1244.09L519.628 1194L534.76 1147.73Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M625.719 636.045C625.882 635.676 626.047 635.303 626.216 634.926C634.827 615.675 651.18 586.371 674.453 555.101C675.309 553.951 676.174 552.799 677.048 551.645C681.292 546.04 685.756 540.382 690.434 534.717C719.458 499.572 756.748 464.148 801.192 439.417C802.633 438.615 804.082 437.824 805.538 437.045C809.425 435.706 813.811 434.265 818.631 432.756C834.065 427.925 853.946 422.398 876.117 417.325C907.634 410.113 943.78 403.816 978.366 401.731C991.004 400.969 1003.43 400.769 1015.35 401.292C1021.01 401.541 1026.56 401.953 1031.96 402.545C1031.96 402.545 1047.01 403.857 1067.14 406.029C928.659 409.67 747.717 438.395 633.598 665C379.319 822.5 173.378 1059.39 183.581 1242.59C163.96 1195.86 147.477 1144.72 135.497 1088.91C130.01 1063.35 125.467 1036.8 122 1009.26C183.698 901.121 311.391 814.501 367.893 784.545C377.366 779.77 387.063 774.757 396.892 769.571C485.041 723.071 583.793 662.736 625.719 636.045Z",
    fill: "#487D38"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.43 405.5C1122.53 405.934 1119.51 405.891 1115.5 405.502C1118.51 405.5 1121.48 405.5 1124.43 405.5Z",
    fill: "#487D38"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M573.827 766.5C564.878 780.333 556.199 806 593.075 798",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M714.543 591C708.845 599.8 703.319 616.126 726.8 611.038",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M264.006 1104.13C255.627 1117.12 247.5 1141.22 282.031 1133.71",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M299.929 1142.95C297.359 1158.14 299.421 1183.46 328.232 1163.23",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M591.218 798.357C591.801 809.266 597.171 826.478 613.995 808.052",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M725.308 610.791C725.672 617.603 729.026 628.352 739.532 616.845",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M279.794 1133.52C280.329 1143.54 285.266 1159.37 300.733 1142.43",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326.098 1163.91C330.561 1172.94 341.37 1185.6 348.9 1164.04",
    stroke: "#29511D",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M813.611 764.778L918.549 722.179L961.831 711C863.289 754.772 660.41 874.609 592.791 999.158C589.56 1004.47 586.106 1010.02 582.49 1015.82C541.695 1081.31 480.474 1179.58 490.787 1346.92C495.355 1432.17 518.559 1535.56 572.867 1662C571.862 1660.03 570.192 1658.49 568.165 1657.62C542.718 1646.65 501.996 1624.99 455.05 1591.05C425.416 1569.62 403.849 1539.16 390.063 1505.29C376.355 1471.61 371.102 1435.09 374.764 1398.91L386.894 1279.05C390.626 1242.17 398.448 1205.82 410.215 1170.67L412.385 1164.19C434.479 1098.19 470.109 1037.53 516.994 986.09L556.886 942.324C583.341 913.3 613.123 887.494 645.616 865.44L720.88 814.355C749.962 794.616 781.044 777.998 813.611 764.778Z",
    fill: "#38642B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M135.497 1088.91C179.587 973.507 300.671 850.387 396.892 769.571C387.063 774.757 377.366 779.77 367.893 784.545C311.391 814.501 183.698 901.121 122 1009.26C125.467 1036.8 130.01 1063.35 135.497 1088.91Z",
    fill: "#579445"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M201.555 1189.76L281.629 1160.65L270.15 1129.07L288.759 1122.31L320.018 1208.3L301.409 1215.07L289.93 1183.49L209.856 1212.6L201.555 1189.76ZM244.563 1292.6C240.344 1284.43 238.23 1276.4 238.219 1268.53C238.254 1260.75 240.156 1253.75 243.923 1247.53C247.779 1241.26 253.262 1236.3 260.371 1232.63C267.57 1228.91 274.772 1227.28 281.978 1227.72C289.319 1228.21 296.035 1230.54 302.126 1234.71C308.306 1238.84 313.276 1244.55 317.036 1251.83C320.658 1258.85 322.403 1265.94 322.271 1273.1C322.273 1280.3 320.323 1286.99 316.421 1293.17C312.608 1299.3 306.835 1304.36 299.104 1308.35C298.304 1308.76 297.348 1309.2 296.236 1309.66C295.212 1310.07 294.233 1310.47 293.299 1310.84L263.241 1252.58L275.372 1246.32L299.789 1293.65L292.063 1287.51C295.796 1285.58 298.65 1283.15 300.625 1280.22C302.6 1277.29 303.655 1274.1 303.791 1270.65C304.015 1267.16 303.209 1263.64 301.375 1260.08C299.541 1256.53 297.113 1253.79 294.092 1251.86C291.206 1249.97 287.951 1249 284.328 1248.96C280.793 1248.87 277.116 1249.81 273.294 1251.78L270.095 1253.44C266.185 1255.45 263.155 1258.09 261.005 1261.33C258.989 1264.62 257.984 1268.24 257.989 1272.17C258.129 1276.15 259.3 1280.27 261.501 1284.54C263.472 1288.36 265.77 1291.4 268.392 1293.64C271.061 1295.98 274.169 1297.75 277.718 1298.96L271.43 1316.21C266.001 1314.85 260.98 1312.21 256.368 1308.29C251.845 1304.32 247.91 1299.09 244.563 1292.6ZM303.999 1387.71L316.912 1378.69L318.882 1375.49L342.003 1359.34C346.102 1356.48 348.412 1352.97 348.933 1348.83C349.511 1344.77 347.997 1340.15 344.39 1334.99C341.928 1331.46 338.921 1328.38 335.369 1325.74C331.956 1323.12 328.476 1321.28 324.93 1320.22L333.526 1303.97C338.587 1305.8 343.589 1308.78 348.532 1312.89C353.476 1317 357.779 1321.67 361.444 1326.92C368.486 1337.01 371.575 1346.5 370.713 1355.39C369.851 1364.29 364.377 1372.26 354.293 1379.3L316.537 1405.66L303.999 1387.71ZM288.931 1368.23C285.324 1363.06 283.093 1358.03 282.239 1353.14C281.466 1348.19 281.91 1343.67 283.569 1339.59C285.229 1335.5 287.944 1332.14 291.716 1329.51C295.651 1326.76 299.753 1325.3 304.022 1325.12C308.347 1325.03 312.79 1326.5 317.349 1329.54C321.991 1332.52 326.659 1337.37 331.354 1344.09L343.634 1361.68L332.443 1369.49L321.622 1354C318.473 1349.49 315.56 1346.89 312.882 1346.2C310.261 1345.59 307.844 1346.05 305.63 1347.6C303.17 1349.32 301.861 1351.63 301.702 1354.55C301.682 1357.49 302.846 1360.64 305.193 1364C307.426 1367.2 310.168 1369.56 313.418 1371.07C316.751 1372.52 320.294 1372.79 324.047 1371.88L317.253 1381.01C312.017 1382.6 307.003 1382.32 302.213 1380.17C297.423 1378.03 292.996 1374.05 288.931 1368.23ZM467.045 1445.7C471.564 1450.23 474.634 1455.15 476.253 1460.46C478.014 1465.76 478.007 1471.28 476.232 1477C474.598 1482.73 470.878 1488.49 465.072 1494.28L432.361 1526.9L415.837 1510.34L445.999 1480.25C450.601 1475.66 453.046 1471.32 453.334 1467.22C453.622 1463.12 452.036 1459.33 448.576 1455.86C446.175 1453.45 443.455 1451.86 440.415 1451.08C437.446 1450.23 434.335 1450.36 431.081 1451.49C427.826 1452.62 424.5 1454.88 421.102 1458.27L392.427 1486.87L375.902 1470.3L406.064 1440.21C410.666 1435.62 413.111 1431.28 413.399 1427.18C413.758 1423.15 412.207 1419.4 408.747 1415.93C406.346 1413.52 403.626 1411.93 400.586 1411.15C397.617 1410.29 394.506 1410.43 391.252 1411.56C387.998 1412.68 384.671 1414.94 381.273 1418.33L352.598 1446.93L336.073 1430.37L393.211 1373.38L408.994 1389.2L393.382 1404.77L394.983 1397.24C400.854 1395.34 406.582 1395.21 412.166 1396.84C417.891 1398.48 423.085 1401.63 427.745 1406.3C432.971 1411.54 436.181 1417.45 437.374 1424.03C438.709 1430.6 437.286 1437.25 433.106 1443.96L428.873 1436.53C435.24 1433.99 441.817 1433.51 448.603 1435.07C455.46 1436.71 461.607 1440.25 467.045 1445.7ZM614.871 1524.94L635.869 1537.17L583.022 1627.91L562.024 1615.68L614.871 1524.94ZM520.806 1591.67L499.808 1579.44L552.656 1488.71L573.653 1500.94L520.806 1591.67ZM585.247 1579.38L540.918 1553.56L551.261 1535.8L595.59 1561.62L585.247 1579.38ZM610.912 1675.28C607.012 1673.72 603.4 1671.58 600.076 1668.85C596.753 1666.12 594.311 1663.2 592.751 1660.1L606.874 1647.82C607.951 1649.97 609.39 1651.89 611.191 1653.58C613.085 1655.31 615.1 1656.6 617.235 1657.45C620.299 1658.68 623.01 1658.9 625.369 1658.12C627.783 1657.47 630.401 1655.77 633.224 1653.03L640.8 1645.39L643.419 1643.7L696.149 1589.83L717.039 1598.18L651.384 1664.17C646.556 1669.24 641.876 1672.86 637.345 1675.03C632.907 1677.24 628.506 1678.28 624.142 1678.15C619.871 1678.06 615.461 1677.1 610.912 1675.28ZM633.808 1655.2L631.528 1563.98L653.95 1572.95L654.783 1645.98L633.808 1655.2ZM737.365 1687.85C729.99 1686.02 723.754 1682.71 718.656 1677.94C713.582 1673.07 710.048 1667.19 708.053 1660.3C706.154 1653.44 706.22 1645.93 708.25 1637.78C710.304 1629.54 713.778 1622.83 718.672 1617.66C723.663 1612.51 729.53 1609.02 736.27 1607.2C743.011 1605.37 750.069 1605.38 757.444 1607.21C764.042 1608.86 769.454 1611.75 773.678 1615.89C777.902 1620.04 780.635 1625.41 781.878 1632C783.121 1638.6 782.595 1646.51 780.3 1655.72C778.029 1664.85 774.834 1672.09 770.716 1677.45C766.622 1682.72 761.738 1686.19 756.064 1687.87C750.488 1689.57 744.254 1689.57 737.365 1687.85ZM745.934 1670.2C749.621 1671.12 753.187 1671.08 756.63 1670.08C760.073 1669.08 763.066 1667.2 765.61 1664.43C768.276 1661.59 770.164 1657.94 771.275 1653.48C772.411 1648.92 772.456 1644.81 771.409 1641.14C770.46 1637.51 768.699 1634.44 766.126 1631.94C763.552 1629.45 760.422 1627.74 756.735 1626.82C752.95 1625.88 749.336 1625.91 745.893 1626.91C742.45 1627.9 739.408 1629.77 736.767 1632.52C734.223 1635.29 732.383 1638.95 731.248 1643.51C730.136 1647.97 730.043 1652.07 730.968 1655.81C732.014 1659.47 733.824 1662.55 736.397 1665.04C738.971 1667.54 742.15 1669.26 745.934 1670.2ZM762.108 1692.78L766.095 1676.77L772.331 1653.59L776.638 1630.08L787.982 1584.52L810.689 1590.17L783.796 1698.18L762.108 1692.78ZM815.14 1704.62L824.92 1624.52L847.105 1627.22L844.342 1649.86L842.015 1642.92C845.088 1637.56 849.431 1633.75 855.044 1631.52C860.668 1629.18 867.252 1628.47 874.796 1629.4L872.179 1650.84C871.198 1650.62 870.311 1650.46 869.517 1650.36C868.735 1650.16 867.897 1650.01 867.004 1649.9C860.651 1649.13 855.265 1650.33 850.846 1653.52C846.539 1656.62 843.918 1661.99 842.985 1669.64L838.368 1707.46L815.14 1704.62ZM923.787 1713.59C917.087 1713.59 911.087 1712.29 905.785 1709.7C900.584 1707.1 896.532 1703.15 893.629 1697.85C890.727 1692.45 889.273 1685.6 889.269 1677.3L889.246 1631.7L912.646 1631.69L912.667 1673.84C912.671 1680.54 914.073 1685.49 916.875 1688.69C919.776 1691.79 923.827 1693.34 929.027 1693.33C932.627 1693.33 935.827 1692.58 938.626 1691.08C941.425 1689.48 943.624 1687.08 945.222 1683.88C946.821 1680.58 947.619 1676.47 947.616 1671.57L947.596 1631.67L970.996 1631.66L971.037 1712.36L948.837 1712.37L948.826 1690.17L952.879 1696.62C950.182 1702.22 946.184 1706.48 940.885 1709.38C935.687 1712.18 929.987 1713.58 923.787 1713.59ZM1030.12 1708.83C1023.27 1709.69 1016.57 1709.72 1010.02 1708.93C1003.56 1708.02 998.339 1706.56 994.357 1704.54L1000.01 1686.9C1003.97 1688.72 1008.52 1690.07 1013.67 1690.93C1018.9 1691.69 1023.95 1691.76 1028.81 1691.15C1034.17 1690.48 1037.86 1689.37 1039.88 1687.8C1042 1686.23 1042.92 1684.3 1042.63 1682.02C1042.4 1680.13 1041.33 1678.85 1039.43 1678.18C1037.62 1677.4 1035.25 1676.94 1032.31 1676.81C1029.37 1676.67 1026.13 1676.57 1022.59 1676.51C1019.16 1676.44 1015.65 1676.22 1012.08 1675.86C1008.5 1675.41 1005.16 1674.51 1002.07 1673.19C998.983 1671.86 996.366 1669.87 994.219 1667.22C992.172 1664.55 990.863 1660.93 990.292 1656.37C989.658 1651.31 990.538 1646.66 992.931 1642.43C995.423 1638.19 999.311 1634.63 1004.59 1631.75C1009.86 1628.77 1016.37 1626.8 1024.11 1625.83C1029.57 1625.15 1035.2 1625.05 1041 1625.53C1046.81 1626.01 1051.74 1627.16 1055.8 1628.97L1050.12 1646.46C1045.97 1644.66 1041.86 1643.61 1037.79 1643.32C1033.81 1642.91 1029.98 1642.93 1026.31 1643.39C1021.15 1644.04 1017.47 1645.21 1015.26 1646.89C1013.05 1648.58 1012.08 1650.52 1012.36 1652.7C1012.61 1654.68 1013.63 1656.07 1015.45 1656.85C1017.36 1657.62 1019.79 1658.12 1022.74 1658.35C1025.69 1658.59 1028.89 1658.74 1032.32 1658.82C1035.84 1658.78 1039.4 1658.99 1042.98 1659.45C1046.57 1659.91 1049.85 1660.8 1052.84 1662.14C1055.92 1663.37 1058.53 1665.31 1060.68 1667.96C1062.81 1670.52 1064.16 1674.08 1064.74 1678.64C1065.36 1683.6 1064.42 1688.21 1061.93 1692.45C1059.42 1696.59 1055.48 1700.11 1050.1 1703C1044.81 1705.88 1038.15 1707.82 1030.12 1708.83Z",
    fill: "url(#paint7_linear_2294_4)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.42 528.89C1270.7 525.798 1265.06 524 1259 524C1251.19 524 1233.87 534.438 1210.5 548.51C1194.37 558.232 1175.35 569.689 1154.6 580.638C1162.95 577.667 1170.37 574.881 1176.32 572.545C1179.92 571.237 1183.41 569.934 1186.8 568.661C1202.93 561.187 1215.73 557.255 1225.74 555.636C1226.87 555.453 1227.96 555.3 1229.02 555.174C1229.91 555.069 1230.77 554.984 1231.61 554.916C1234.6 554.605 1237.42 554.574 1240.06 554.878C1246.2 555.39 1250.46 557.13 1253.22 559.288C1254.95 560.643 1256.09 562.163 1256.72 563.647C1262.3 557.526 1266.5 551.448 1269.56 545.494C1272.48 539.823 1274.37 534.265 1275.42 528.89Z",
    fill: "#AAB342"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2294_4",
    x1: 809.419,
    y1: 0,
    x2: 809.419,
    y2: 1618.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#351E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2294_4",
    x1: 1777.99,
    y1: 709,
    x2: 1777.99,
    y2: 973.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698764",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2294_4",
    x1: 264.682,
    y1: 750,
    x2: 264.682,
    y2: 963.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698764",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2294_4",
    x1: 970.117,
    y1: 200.833,
    x2: 970.754,
    y2: 287.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698764",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2294_4",
    x1: 1247.53,
    y1: 1169.76,
    x2: 1255.46,
    y2: 1624.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698764",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2294_4",
    x1: 1276.3,
    y1: 553.462,
    x2: 866,
    y2: 606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFCB37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFCB37",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2294_4",
    x1: 1372.63,
    y1: 761,
    x2: 1224.02,
    y2: 577.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1B0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2294_4",
    x1: 157.469,
    y1: 1027.78,
    x2: 908.884,
    y2: 1711.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF268"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2294_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1868,
    height: 1868,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrus);
export default __webpack_public_path__ + "static/media/Hydrus.2b00e5166cb9d52fc3d668b57f325118.svg";
export { ForwardRef as ReactComponent };